import getFavItems from "./getFavItems";
import putFavItems from "./putFavItems";

export default (product) => {
  getFavItems().then((feed) => {
      if (feed.indexOf(product) < 0) {
          feed.push(product);
          putFavItems(feed);
      }
  });
}
